import { useEffect, useRef, useState } from "react";
import { Play } from "@phosphor-icons/react";
import client from "../lib/api";

const DEMO_60S = "https://res.cloudinary.com/uitih20u/video/upload/v1791957580/freightpilotai/demo_ads/demo_ad_b85fd71d41f941fb.mp4";

export default function PricingDemoClip({ className = "relative z-10 max-w-md mx-auto px-4 -mt-2 mb-10", testId = "pricing-demo-clip" }) {
  const [clip, setClip] = useState(null);
  const [full, setFull] = useState(false);
  const [blocked, setBlocked] = useState(false);
  const ref = useRef(null);
  useEffect(() => { client.get("/public/demo-clip").then((r) => setClip(r.data.clip)).catch(() => {}); }, []);
  useEffect(() => {
    // iPhone Low Power Mode and some browsers refuse muted autoplay — fall back to a tap-to-play poster
    const v = ref.current;
    if (!v || full) return;
    const p = v.play?.();
    if (p && p.catch) p.catch(() => setBlocked(true));
  }, [clip, full]);
  if (!clip) return null;
  const src = full ? DEMO_60S : clip.cdn_url || `${process.env.REACT_APP_BACKEND_URL}${clip.mp4_url}`;
  // Cloudinary frame grab at 1.5 s (frame 0 is the fade-in from black)
  const poster = (clip.cdn_url || "").replace(/\.mp4$/, ".jpg").replace("/video/upload/", "/video/upload/so_1.5/") || undefined;
  const tapPlay = () => { setBlocked(false); ref.current?.play?.().catch(() => {}); };
  return (
    <section className={className} data-testid={testId}>
      <div className="relative rounded-2xl overflow-hidden border border-white/10 bg-black shadow-[0_30px_80px_-30px_rgba(255,90,31,0.35)]">
        <video
          ref={ref}
          key={src}
          src={src}
          poster={full ? undefined : poster}
          autoPlay={!full}
          muted={!full}
          loop={!full}
          controls={full}
          playsInline
          preload="metadata"
          className="w-full aspect-square object-cover"
          data-testid="pricing-demo-clip-video"
        />
        {blocked && !full && (
          <button type="button" onClick={tapPlay} className="absolute inset-0 flex items-center justify-center bg-black/30" aria-label="Play demo" data-testid="pricing-demo-clip-play">
            <span className="inline-flex items-center gap-2 rounded-full bg-[#FF5A1F] text-black font-bold px-5 py-3 text-sm"><Play size={16} weight="fill" /> Play 12-second demo</span>
          </button>
        )}
      </div>
      <div className="flex items-center justify-between mt-2 px-1">
        <span className="text-[11px] uppercase tracking-widest text-neutral-500">Real screens from the app · {full ? "60 s with sound" : `${Math.round(clip.duration_sec || 12)} s`}</span>
        {!full && (
          <button type="button" onClick={() => setFull(true)} className="inline-flex items-center gap-1 text-xs font-bold text-[#FF9764] hover:text-white" data-testid="pricing-demo-clip-full">
            <Play size={12} weight="fill" /> Watch the 60-second demo
          </button>
        )}
      </div>
    </section>
  );
}
